
















































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { sleep, getFileName } from '@/utils/helpers'
import config from '@/config'
import UserActionMixin from '@/mixins/UserActionMixin'

export default mixins(UserActionMixin).extend({
  name: 'MediaContainer',
  props: {
    menus: {
      type: Array,
      default: () => ['download']
    },
    mediaUrl: {
      type: String,
      required: true
    },
    mediaType: {
      type: String,
      required: true,
      validator: (value: string) => /(photo|video)/.test(value)
    },
    mediaThumbnail: {
      type: String,
      default: ''
    },
    savePhotoPoint: {
      type: [Number, String],
      default: 0
    },
    saveVideoPoint: {
      type: [Number, String],
      default: 0
    },
    requestUrl: {
      type: String,
      default: ''
    },
    requestParams: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: null
    }
  },
  computed: {
    isMan(): boolean {
      return (this.$store as any).getters['MyData/isMan']
    },
    style(): any {
      return {
        width: 'auto',
        height: '100%',
        'object-fit': 'contai'
      }
    },
    isPhoto(): boolean {
      return this.mediaType === 'photo'
    },
    isVideo(): boolean {
      return this.mediaType === 'video'
    },
    hasDownlaod(): boolean {
      return Array.isArray(this.menus) ? this.menus.indexOf('download') >= 0 : false
    },
    // 購入してすぐのファイル URL にはクエリが付与されていて
    // このままだとダウンロードに失敗してしまうので削除する
    downloadUrl(): string {
      return (this.mediaUrl as string).split('?')[0]
    }
  },
  methods: {
    /**
     * ファイルのダウンロード
     */
    async download() {
      if (!this.$_hasCordova) {
        this.$_alert('ファイルの保存機能が使えるのはアプリだけです。')
        return
      }

      let typeLabel, savePoint
      if (this.isPhoto) {
        typeLabel = '写真'
        savePoint = this.savePhotoPoint
      } else if (this.isVideo) {
        typeLabel = '動画'
        savePoint = this.saveVideoPoint
      }

      let message = `${typeLabel}を保存しますか？`
      if (this.isMan) {
        message = `${savePoint}ptsを使ってこの` + message
      }
      const title = `${typeLabel}の保存`
      const buttonIndex = await this.$_confirm(message, title, ['キャンセル', '保存する'])
      if (!this.$_clickedConfirmOK(buttonIndex)) {
        return
      }

      // 保存処理開始
      this.loading = this.$loading.open({ isFullPage: true })

      const params = { ...this.requestParams, page: 'save_file' }
      const path = this.$_platformIsAndroid
        ? cordova.file.externalRootDirectory + config.APP_DATA_DIR + '/'
        : this.$_platformIsIOS
        ? cordova.file.tempDirectory
        : ''
      const dirname = 'download/'
      const filename = getFileName(this.downloadUrl)
      const filePath = `${path}${dirname}${filename}`

      try {
        if (this.isMan) {
          // ファイルの保存リクエスト
          const resDownloadReq = await this.$http.post(this.requestUrl, params)
          let error = resDownloadReq.data.error
          if (error) {
            if (typeof error === 'string') {
              this.$_alert(error)
            } else if (error.code === 9) {
              await this.$_showPointBuyDialog(error.description, error.message)
            } else {
              this.$_alert(error.description, error.message)
            }
            this.loading.close()
            return
          }
        }

        if (!(await this.$_mightRequestPhotoLibraryAuthorization())) {
          this.loading.close()
          this.$_alert('もう一度ファイルをタップしてギャラリーへのアクセスを許可してください。')
          return
        }

        if (this.$_platformIsAndroid) {
          // Android 用のデータディレクトリの準備
          await this.$_initAppDataDir()
        }
        // ダウンロード用ディレクトリを作成
        await this.$_createDir(path, dirname)
        // ファイルを一時的にダウンロード
        await this.$_downloadFileTransfer(this.downloadUrl, filePath, {})

        // ファイルをアルバムに保存
        if (this.isPhoto) {
          await this.$_saveImagePhotoLibrary(filePath, this.$store.getters['AppInfo/appName'])
        } else if (this.isVideo) {
          await this.$_saveVideoPhotoLibrary(filePath, this.$store.getters['AppInfo/appName'])
        }

        if (this.isMan) {
          // 保存成功を POST(サーバがこれを受け取ったらポイント処理)
          const okRes = await this.$http.post(this.requestUrl, { ...params, save: true })
          if (okRes.data.error) {
            this.$_alert(okRes.data.error)
            this.loading.close()
            return
          }
        }

        this.$_alert(`${typeLabel}を保存しました`)
        await sleep(300)
        this.loading.close()
      } catch (err) {
        console.error(err)
        this.$_alert(`${typeLabel}の保存に失敗\n${err}`)
        this.loading.close()
      } finally {
        // ダウンロードディレクトリごと必ず削除
        setTimeout(async () => {
          if (this.$_existsPath(filePath)) {
            await this.$_removeDir(path + dirname)
          }
        }, 1000)
      }
    }
  }
})
